var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"upload",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onChange}}),_c('a-button',{attrs:{"loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.list.length > 0 ? _vm.list[0].name : '点击上传')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }